import React from 'react'
import styled from 'styled-components'
import { accents } from 'sutra/tokens/colors'

import { AUTH_CARD_WIDTH } from 'features/auth/components/AuthCard/AuthCard'
import { FullHeightWrapper } from 'features/auth/components/FullHeightWrapper'
import { MarketingCTASigninPage } from 'features/auth/components/MarketingCtaSigninPage'

interface AuthLayoutProps {
  children: React.ReactNode
  showSignUp?: boolean
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  showSignUp = false,
}) => {
  return (
    <FullHeightWrapper
      style={{
        display: 'flex',
        flexDirection: 'row',
        height: '100vh',
        width: '100vw',
      }}
    >
      <LeftColumn>
        <Center>
          {children}

          {showSignUp && (
            <SignUp>
              {"Don't have an account?"}{' '}
              <SignUpLink href="https://meetyogi.com/book-a-demo">
                Sign up
              </SignUpLink>
            </SignUp>
          )}
        </Center>

        <Footer className="footer">
          <Links>
            <PageLink
              href="https://yogi-app.s3.us-west-2.amazonaws.com/YogiTermsAndConditions.pdf"
              target="_blank"
            >
              Terms of Use
            </PageLink>
            <PageLink
              href="https://yogi-app.s3.us-west-2.amazonaws.com/YogiPrivacyPolicy.pdf"
              target="_blank"
            >
              Privacy Policy
            </PageLink>
          </Links>
        </Footer>
      </LeftColumn>

      <RightColumn>
        <MarketingCTASigninPage />
      </RightColumn>
    </FullHeightWrapper>
  )
}

const LeftColumn = styled.div`
  align-items: center;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  padding: 24px 30px;
`

const RightColumn = styled.div`
  height: 100vh;
`

const Center = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`

const SignUp = styled.div`
  display: block;
  width: ${AUTH_CARD_WIDTH}px;
  font-weight: 400;
  text-align: left;
  font-size: 13px;
  color: var(--color-auth-grey);
  padding: 0 24px;
`

const SignUpLink = styled.a`
  color: ${accents.reflectionBlue[500]};
  font-size: 13px;

  :hover {
    text-decoration: underline;
  }
`

const Footer = styled.div``

const Links = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  margin-top: 8px;

  a {
    position: relative;
    margin-left: 22px;
  }

  a::before {
    content: '';
    display: block;
    position: absolute;
    left: -13px;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #acb5bd;
  }

  a:first-child {
    margin-left: 0;
  }

  a:first-child::before {
    display: none;
  }
`

const PageLink = styled.a`
  color: #acb5bd;
  text-decoration: underline;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
`
